import React from 'react';
import { Modal } from 'bootstrap';
import { connect } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import Ax from "../../components/hoc/Ax";
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../components/TapUi';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import AppBaseComponent from '../../components/AppBaseComponent';
import tapIcon from '../../services/TapIcon';
import { Helmet } from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import { toast } from 'react-toastify';
import InputAssetSearch from '../includes/ui/InputAssetSearch';
import TapSelect from '../../components/ui/TapSelect';
import moment from 'moment';
import download from '../../services/DownloadFile';
import swal from "sweetalert";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TapHelper from '../../services/TapHelper';
import InputTicketSearch from '../includes/ui/InputTicketSearch';
import InputProjectSearch from '../includes/ui/InputProjectSearch';
import TapInput from '../../components/ui/TapInput';
import VoucherForDisplay from '../includes/ui/VocuherForDisplay';
import ExpenseView from './ExpenseView';

class Expense extends AppBaseComponent {
    constructor(props) {
        super(props);

        this.expenseSearchInitState = {
            'search_transaction_id': '',
            'search_expense_heads': [],
            'search_wallet_ids': [],
            'search_ticket_ids': [],
            'search_amount': '',
            'search_payee': '',
            'search_asset_ids': [],
            'asset_group_ids': [],
            'search_asset_type_ids': [],
            'search_site_ids': [],
            'date_range': '',
            'date_range_start': null,
            'date_range_end': null,
            'entry_date_range': '',
            'entry_date_range_start': null,
            'entry_date_range_end': null,
            'transaction_delay': '',
            'search_project_ids': []
        };

        this.expenseSearchFormLabel = {
            'search_asset_ids': 'Asset : ',
            'search_expense_heads': 'Expense Head : ',
            'search_wallet_ids': 'Wallet : ',
            'search_ticket_ids': 'Ticket : ',
            'asset_group_ids': 'Asset Type Groups : ',
            'search_asset_type_ids': 'Asset Type : ',
            'search_site_ids': 'Site : ',
            'search_amount': 'Amount : ',
            'search_payee': 'Payee : ',
            'search_transaction_id': 'Transaction ID : ',
            'search_project_ids': 'Project : ',
            'date_range': 'Transaction Period : ',
            'entry_date_range': 'Date of Entry : ',
            'transaction_delay': 'Transaction Delay : '
        };

        this.detailUrl = IAM_API_BASE_URL_2 + '/expense/detail/';
        this.formDataUrl = IAM_API_BASE_URL_2 + '/expense/list_form_data';
        this.listUrl = IAM_API_BASE_URL_2 + '/expense/listing';
        this.projectUrl = IAM_API_BASE_URL_2 + "/project/detail/_replace_id";

        this.state = {
            minimizeTable: false,
            listing_loading: false,
            listing_tbl_page: 1,
            expense_listing: [],
            listingMeta: null,
            totalListingCount: 0,
            expenseData: null,
            viewDataLoading: false,
            access_token: '',
            all_periods: [],
            searchedAssets: [],
            iam_asset_types: [],
            iam_group_sites: [],
            expenseSearchForm: { ...this.expenseSearchInitState },
            formSearchedElems: [],
            expenseSearchParams: null,
            file_downloading: false,
            allTransactionDelay: [],
            allPayee: [],
            allExpenseHead: [],
            allWalletList: [],
            allAssetTypesGroupsList: [],
            pdf_downloading: false,
            searchedTickets: [],
            criteriaHeight: 0,
            searchedProjects: [],
            expenseHeads: [],
            isInitialLoad: true,
            selectedExpenseId: null
        };
        this.criteriaRef = React.createRef();
        this.expenseSearchModal = null;
        this.isViewingDetail = false;
    }

    componentDidMount() {
        this.setState({ access_token: this.props.access_token, listing_loading: true });

        const paramObject = new URLSearchParams(this.props.location.search);
        const expenseId = this.props?.match?.params?.id ||
            this.props?.location?.state?.id ||
            paramObject?.get('transaction_id');

        if (expenseId) {
            this.selectedExpenseId = expenseId;
            this.setState({ minimizeTable: true, selectedExpenseId: expenseId });
        }

        this.searchFormDataInit(this.props);
        this.expenseSearchModal = new Modal(document.getElementById('expenseSearchModal'), {
            keyboard: false,
            backdrop: false
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => this.updateCriteriaHeight(), 100);
        }

        if (this.state.selectedExpenseId &&
            this.state.selectedExpenseId !== prevState.selectedExpenseId &&
            !this.isViewingDetail) {
            this.isViewingDetail = true;
            this.viewExpenseDetail(this.state.selectedExpenseId);
        }
    }

    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };

    searchFormDataInit = (props) => {
        const all_periods = [...props.all_periods, { key: 'custom', display: 'Custom Date Range' }];

        HttpAPICall.withAthorization('GET', this.formDataUrl, this.props.access_token, {})
            .then((response) => {
                this.setState({
                    iam_asset_types: props.iam_asset_types ? props.iam_asset_types.map((at) => ({
                        value: at.id,
                        label: at.asset_type_name
                    })) : [],
                    iam_group_sites: props.iam_group_sites ? props.iam_group_sites.map((s) => ({
                        value: s.id,
                        label: `${s.site_name} (${s.site_code})`
                    })) : [],
                    all_periods: all_periods,
                    allTransactionDelay: response.data?.transactional_delay?.map((td) => ({
                        value: td.key,
                        label: td.text
                    })) || [],
                    allExpenseHead: response.data?.heads?.map((td) => ({
                        value: td.id,
                        label: td.expense_head
                    })) || [],
                    allWalletList: response.data?.wallets?.map((td) => ({
                        value: td.id,
                        label: td.wallet_name
                    })) || [],
                    allPayee: [{ value: 'vendor', label: 'Vendors' },
                    { value: 'employee', label: 'Employees' },
                    { value: 'other', label: 'Other' }],
                    allAssetTypesGroupsList: props.asset_groups?.map(oc => ({
                        value: oc.id,
                        label: oc.name,
                        linked_asset_types: oc.asset_type_ids
                    })) || []
                }, () => this.handleUrlParams());
            });
    };

    handleUrlParams = () => {
        const ParamObject = new URLSearchParams(this.props.location.search);

        if (ParamObject.get('search_site_ids') || ParamObject.get('entry_date_range') || ParamObject.get('transaction_delay')) {
            const updateFilterForm = {
                'entry_date_range': ParamObject.get('entry_date_range'),
                'transaction_delay': ParamObject.get('transaction_delay')
            };

            if (ParamObject.get('search_site_ids')) {
                updateFilterForm['search_site_ids'] = [ParamObject.get('search_site_ids')];
            }

            setTimeout(() => {
                this.setState({ expenseSearchForm: { ...this.state.expenseSearchForm, ...updateFilterForm } },
                    () => this.expenseSearchFormSubmit());
            }, 1);
        } else if (ParamObject.get('search_project_id')) {
            this.getProjectDetail(ParamObject.get('search_project_id'));
        } else if (!this.state.selectedExpenseId) {
            this.loadListingTblData(1);
        } else {
            // If we have selected expense ID, load listing after detail
            this.loadListingTblData(1);
        }
    };

    getProjectDetail = (id) => {
        HttpAPICall.withAthorization("GET", this.projectUrl.replace('_replace_id', id), this.props.access_token, null, null, (resp) => {
            const projectDetail = resp.data.data;
            if (projectDetail) {
                this.setState({
                    searchedProjects: [{
                        label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                        display_label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                        value: projectDetail.id
                    }],
                    expenseSearchForm: { ...this.state.expenseSearchForm, search_project_ids: [projectDetail.id] }
                }, () => this.expenseSearchFormSubmit());
            }
        });
    };

    loadListingTblData = (page = 1) => {
        this.setState({ listing_loading: true, listing_tbl_page: page });
        const params = { page: page, ...this.state.expenseSearchParams };

        HttpAPICall.withAthorization('GET', this.listUrl, this.props.access_token, params, {}, (resp) => {
            const respData = resp.data.expenses;
            this.setState({
                expense_listing: respData.data,
                listingMeta: {
                    total: respData.total,
                    from: respData.from,
                    to: respData.to,
                    current_page: respData.current_page,
                    last_page: respData.last_page,
                    per_page: respData.per_page
                },
                totalListingCount: respData.total,
                expenseHeads: resp.data.expense_heads
            });
        }).finally(() => this.setState({ listing_loading: false }));
    };

    expenseSearchModalInit = () => {
        this.expenseSearchModal?.show();
    };

    expenseSearchClear = () => {
        this.setState({
            formSearchedElems: [],
            expenseSearchParams: null,
            searchedAssets: [],
            searchedProjects: [],
            expenseSearchForm: { ...this.expenseSearchInitState }
        }, () => {
            this.expenseSearchModal?.hide();
            this.loadListingTblData(1);
            this.setState({ criteriaHeight: 0 });
        });
    };

    expenseSearchFormSubmit = (event = null) => {
        event?.preventDefault();

        const serachFormKeys = Object.keys(this.state.expenseSearchForm);
        const searchedElems = [];
        const expenseSearchParams = {};

        serachFormKeys.forEach(key => {
            const label = this.expenseSearchFormLabel[key];
            let value = this.state.expenseSearchForm[key];

            if (value && value !== "Invalid date" && value.length > 0) {
                expenseSearchParams[key] = value;

                if (label) {
                    let show_val = this.getSearchDisplayValue(key, value);
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });

        this.setState({
            formSearchedElems: searchedElems,
            expenseSearchParams: expenseSearchParams
        }, () => {
            this.expenseSearchModal?.hide();
            this.loadListingTblData(1);
        });
    };

    getSearchDisplayValue = (key, value) => {
        const displayMap = {
            'search_asset_ids': () => this.state.searchedAssets?.map(s => s.display_label).join(', ') || '',
            'search_ticket_ids': () => this.state.searchedTickets?.map(s => s.value).join(', ') || '',
            'search_project_ids': () => this.state.searchedProjects?.map(s => s.display_label).join(', ') || '',
            'asset_group_ids': () => this.state.allAssetTypesGroupsList.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_asset_type_ids': () => this.state.iam_asset_types.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_site_ids': () => this.state.iam_group_sites.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'transaction_delay': () => this.state.allTransactionDelay.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_expense_heads': () => this.state.allExpenseHead.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_wallet_ids': () => this.state.allWalletList.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_payee': () => this.state.allPayee.filter(s => value.includes(s.value)).map(s => s.label).join(', '),
            'search_amount': () => this.state.expenseSearchForm?.search_amount || '',
            'search_transaction_id': () => this.state.expenseSearchForm?.search_transaction_id || '',
            'search_payee_name': () => this.state.expenseSearchForm?.search_payee_name || '',
            'date_range': () => {
                const start = moment(this.state.expenseSearchForm.date_range_start).format('DD-MMM-YYYY');
                const end = moment(this.state.expenseSearchForm.date_range_end).format('DD-MMM-YYYY');
                const displayCustom = `Custom Date Range (${start} - ${end})`;
                return this.state.all_periods.filter(s => value.includes(s.key)).map(s => s.display_with_date || displayCustom);
            },
            'entry_date_range': () => {
                const start = moment(this.state.expenseSearchForm.entry_date_range_start).format('DD-MMM-YYYY');
                const end = moment(this.state.expenseSearchForm.entry_date_range_end).format('DD-MMM-YYYY');
                const displayCustom = `Custom Date Range (${start} - ${end})`;
                return this.state.all_periods.filter(s => value.includes(s.key)).map(s => s.display_with_date || displayCustom);
            }
        };

        return displayMap[key] ? displayMap[key]() : value;
    };

    viewExpenseDetail = (id) => {
        if (this.isViewingDetail && this.state.selectedExpenseId === id && this.state.expenseData) {
            return;
        }

        this.setState({ minimizeTable: true, selectedExpenseId: id });
        this.isViewingDetail = true;
        this.getExpenseDetail(id);
    };

    closeView = () => {
        this.setState({ minimizeTable: false, selectedExpenseId: null });
        this.isViewingDetail = false;
        this.props.history.push("/expense_list");
    };

    getExpenseDetail = (id) => {
        if (this.state.expenseData?.detail?.transaction_id === id) {
            return;
        }

        this.setState({ viewDataLoading: true });
        HttpAPICall.withAthorization('GET', this.detailUrl + id, this.state.access_token || this.props.access_token, {}, {},
            (response) => {
                this.setState({ expenseData: response.data, viewDataLoading: false });
            },
            (error) => {
                toast.error(error?.msg || 'Error loading expense details', { position: toast.POSITION.TOP_RIGHT });
                this.setState({ viewDataLoading: false });
            }
        );
    };

    expenseDownloadHandler = () => {
        const params = { ...this.state.expenseSearchParams };

        if (this.state.expenseSearchParams !== null) {
            this.expenseDownloadStart(params);
        } else {
            swal({
                title: "Download",
                text: "The download will be for Current Month's Transaction, in case you want different Transaction Period then please change by filter.",
                icon: "warning",
                buttons: ["Cancel", "Okay"],
            }).then(willDownload => {
                if (willDownload) {
                    params.date_range = "current_month";
                    this.expenseDownloadStart(params);
                }
            });
        }
    };

    expenseDownloadStart = (params) => {
        this.setState({ file_downloading: true });
        HttpAPICall.withAthorization('GET', this.listUrl, this.props.access_token, { action: "download", ...params }, {},
            (response) => {
                download.file(response.data.file_path);
            }
        ).finally(() => this.setState({ file_downloading: false }));
    };

    expensePdfDownloadHandler = () => {
        this.setState({ pdf_downloading: true });
        HttpAPICall.withAthorization('GET', this.detailUrl + this.state?.expenseData?.detail?.transaction_id, this.props.access_token,
            { action: "download" }, {},
            (response) => {
                download.file(response.data.file_path);
            }
        ).finally(() => this.setState({ pdf_downloading: false }));
    };

    expenseAddInit = () => {
        this.props.history.push("/expense_add");
    };

    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    };

    tapSelectChange = (selectedOption, formName, fieldName) => {
        const value = selectedOption ? (Array.isArray(selectedOption) ? selectedOption.map(o => o.value) : selectedOption.value) :
            (Array.isArray(selectedOption) ? [] : '');
        this.setState({
            [formName]: {
                ...this.state[formName],
                [fieldName]: value
            }
        });
    };
    expenseEditInit = () => {
        const expenseId = this.state?.expenseData?.detail?.transaction_id;
            this.props.history.push({
                pathname: "/expense_edit/" + expenseId,
                state: { expenseDetailData: this.state.expenseData }
            });
    };
    expensePaymentInit = () => {
        const expenseId = this.state?.expenseData?.detail?.transaction_id;
        this.props.history.push({
            pathname: "/payment_add",
            state: { expenseData: this.state.expenseData?.detail }
        });
    };

    expenseListjsx = () => {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                        <h3>Expense List</h3>
                        <div className="text-end mt15">
                            {!this.state.minimizeTable && (<>
                                <button type="button" disabled={this.state.listing_loading}
                                    onClick={this.expenseAddInit} className="btn btn-primary">
                                    Add
                                </button>
                                <button type="button" className="btn btn-secondary"
                                    disabled={this.state.file_downloading || this.state.listing_loading}
                                    onClick={this.expenseDownloadHandler}>
                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                                    {this.state.file_downloading && (
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />
                                    )}
                                </button>
                            </>
                            )}
                            <button type="button" onClick={this.expenseSearchModalInit} className="btn btn-secondary">
                                <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </div>
                    </div>
                    {this.state.minimizeTable && (
                        <div className="col-9 tap_border_left">
                            <h3 className="text-capitalize">
                                Expense : {this.state.expenseData?.detail?.transaction_id || "-"}
                            </h3>
                            <div className="text-end mt15">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.pdf_downloading || this.state.viewDataLoading}
                                    onClick={() => this.expensePaymentInit()}
                                >
                                    Payment
                                </button>
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary" disabled={this.state.detailpdf_downloading || this.state.viewDataLoading}>
                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li onClick={() => this.expenseEditInit()}><button className="dropdown-item" role="button"
                                    >Edit</button></li>
                                </ul>
                                <button type="button" className="btn btn-secondary"
                                    disabled={this.state.pdf_downloading || this.state.viewDataLoading}
                                    onClick={this.expensePdfDownloadHandler}>
                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                                    {this.state.pdf_downloading && (
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />
                                    )}
                                </button>
                                <button onClick={this.closeView} type="button" className="btn btn-secondary">
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={["pageTbl", this.state.minimizeTable ? "col-3" : "col-12"].join(" ")}>
                            {this.expenseListingTableJsx()}
                        </div>
                        {this.state.minimizeTable && (
                            <div className="col-9 pr4 pl4 bg-white pageTbl">
                                {this.state.viewDataLoading ? (
                                    <Loader />
                                ) : (
                                    <div className="tab_content_header">
                                        <ExpenseView expenseData={this.state.expenseData} showActionData={true} props={this.props} />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Ax>
        );
    };

    expenseListingTableJsx = () => {
        return (
            <Ax>
                <div ref={this.criteriaRef}
                    style={{ position: 'sticky', top: 0, background: 'white' }}>
                    <DisplaySearchCriteria searchedElems={this.state.formSearchedElems}
                        onClearFilter={this.expenseSearchClear} />
                </div>
                <table className="table table-bordered bg-white table-sm">
                    <thead className="table-secondary" style={{
                        top: `${this.state.criteriaHeight}px`,
                        position: 'sticky'
                    }}>
                        {this.state.minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "15%" }}>Expense</th>
                            </tr>
                        ) : (
                            <tr>
                                <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                <th scope="col" style={{ width: "10%" }} className='text-center'>Date</th>
                                <th scope="col" style={{ width: "8%" }}>Transaction ID</th>
                                <th scope="col" style={{ width: "15%" }}>Expense For</th>
                                <th scope="col" style={{ width: "13%" }}>Expense Head</th>
                                <th scope="col" style={{ width: "13%" }}>Description</th>
                                <th scope="col" style={{ width: "13%" }}>Wallet</th>
                                <th scope="col" style={{ width: "13%" }}>Vendor</th>
                                <th scope="col" style={{ width: "7%" }} className='text-end'>Amount</th>
                                <th scope="col" style={{ width: "5%" }}>Action</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {this.state.listing_loading ? (
                            <tr><td colSpan="10"><Loader /></td></tr>
                        ) : this.state.expense_listing.length > 0 ? (
                            this.state.expense_listing.map((expense, index) => (
                                <tr key={expense.transaction_id || index}>
                                    {this.state.minimizeTable ? (
                                        <td style={{ width: "25%" }}>
                                            <Link to={{ pathname: "/expense_list/" + expense.transaction_id }}
                                                onClick={() => this.viewExpenseDetail(expense.transaction_id)}>
                                                <div className="text-capitalize link-primary cursor_pointer">
                                                    {expense.transaction_id || "-"}
                                                </div>
                                            </Link>
                                        </td>
                                    ) : (
                                        <Ax key={expense.transaction_id}>
                                            <td className="text-center">{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                            <td className='text-center'>{expense.expense_date || "-"}</td>
                                            <td className='link-primary cursor_pointer'>
                                                <Link to={{ pathname: "/expense_list/" + expense.transaction_id }}
                                                    onClick={() => this.viewExpenseDetail(expense.transaction_id)}>
                                                    {expense.transaction_id || "-"}
                                                </Link>
                                            </td>
                                            <td><VoucherForDisplay item={expense} /></td>
                                            <td>
                                                {
                                                    expense.expense_detail && Array.isArray(expense.expense_detail) && expense.expense_detail.length > 0
                                                        ? expense.expense_detail.map(d => {
                                                            const head = this.state.expenseHeads?.find(eh => eh.id == d.head);
                                                            return head?.expense_head || '';
                                                        }).join(', ')
                                                        : '-'
                                                }
                                            </td>
                                            <td>{expense.details || '-'}</td>
                                            <td>{expense.walletData?.wallet_name || '-'}</td>
                                            <td>
                                                {expense?.vendor && expense?.vendor?.name ||"-"}
                                            </td>
                                            <td className='text-end'>₹ {expense.amount || '-'}</td>
                                            <td className="text-center">
                                                <button type="button" data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    <li>
                                                        <Link to={{ pathname: "/expense_list/" + expense.transaction_id }}
                                                            className="dropdown-item" role="button"
                                                            onClick={() => this.viewExpenseDetail(expense.transaction_id)}>
                                                            View
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </Ax>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="10" className="text-center">No Records</td></tr>
                        )}
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={this.state.listingMeta}
                    onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
                />
            </Ax>
        );
    };

    expenseSearchModalJsx = () => {
        return (
            <div className="modal fade" id="expenseSearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="expenseSearchModalLabel">Expense Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.expenseSearchFormSubmit} id="expenseSearchForm">
                            <div className="modal-body">
                                {/* Transaction ID */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction ID</label>
                                    <div className="col-sm-10">
                                        <TapInput
                                            name="search_transaction_id"
                                            className="form-control form-control-sm"
                                            placeholder="Transaction ID"
                                            autoComplete="off"
                                            value={this.state.expenseSearchForm.search_transaction_id}
                                            onChange={(e) => this.formInputHandler(e, "expenseSearchForm")}
                                        />
                                    </div>
                                </div>

                                {/* Expense Head */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Expense Head</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allExpenseHead}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_expense_heads')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allExpenseHead.filter(s => this.state.expenseSearchForm.search_expense_heads.includes(s.value))}
                                            placeholder="Select Expense Head"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Expense Amount */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Expense Amount</label>
                                    <div className="col-sm-10">
                                        <TapInput
                                            name="search_amount"
                                            className="form-control form-control-sm"
                                            placeholder="Example: 0-5 for a range or 4 for specific Expense Amount"
                                            autoComplete="off"
                                            value={this.state.expenseSearchForm.search_amount}
                                            onChange={(e) => this.formInputHandler(e, "expenseSearchForm")}
                                        />
                                    </div>
                                </div>

                                {/* Asset */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset</label>
                                    <div className="col-sm-10">
                                        <InputAssetSearch
                                            containerHeight="30px"
                                            fontSize="93%"
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_asset_ids');
                                                this.setState({ searchedAssets: selectedOption || [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedAssets.map(a => ({ ...a, label: a.display_label }))}
                                        />
                                    </div>
                                </div>

                                {/* Asset Type Group */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset Type Group</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allAssetTypesGroupsList}
                                            changeEvent={(selectedOption) => {
                                                this.setState({
                                                    expenseSearchForm: {
                                                        ...this.state.expenseSearchForm,
                                                        asset_group_ids: selectedOption?.map(o => o.value) || [],
                                                        search_asset_type_ids: selectedOption?.map(s => s.linked_asset_types).flat() || []
                                                    }
                                                });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allAssetTypesGroupsList.filter(s => this.state.expenseSearchForm.asset_group_ids.includes(s.value))}
                                            placeholder="Select Asset Type Group"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Asset Type */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset Type</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.iam_asset_types}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_asset_type_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.iam_asset_types.filter(s => this.state.expenseSearchForm.search_asset_type_ids.includes(s.value))}
                                            placeholder="Select Asset Type"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Ticket */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Ticket</label>
                                    <div className="col-sm-10">
                                        <InputTicketSearch
                                            containerHeight="30px"
                                            fontSize="93%"
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_ticket_ids');
                                                this.setState({ searchedTickets: selectedOption || [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedTickets.map(a => ({ ...a, label: a.display_label }))}
                                            search_exclude_ticket_status={[26, 10]}
                                        />
                                    </div>
                                </div>

                                {/* Site */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Executed Site</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.iam_group_sites}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_site_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.iam_group_sites.filter(s => this.state.expenseSearchForm.search_site_ids.includes(s.value))}
                                            placeholder="Select Executed Site"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Transaction Delay */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction Delay</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allTransactionDelay}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'transaction_delay')}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={this.state.allTransactionDelay.find(s => this.state.expenseSearchForm.transaction_delay === s.value)}
                                            placeholder="Select Transaction Delay"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Wallet */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Wallet</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allWalletList}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_wallet_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allWalletList.filter(s => this.state.expenseSearchForm.search_wallet_ids.includes(s.value))}
                                            placeholder="Select Wallet"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Payee */}
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Payee</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allPayee}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_payee')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allPayee.filter(s => this.state.expenseSearchForm.search_payee.includes(s.value))}
                                            placeholder="Select Payee"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                {/* Project */}
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Project</label>
                                    <div className="col-sm-10">
                                        <InputProjectSearch
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'expenseSearchForm', 'search_project_ids');
                                                this.setState({ searchedProjects: selectedOption || [] });
                                            }}
                                            placeholder="Search Project"
                                            isMulti={true}
                                            containerHeight="30px"
                                            fontSize="93%"
                                            value={this.state.searchedProjects.map(a => ({ ...a, label: a.display_label }))}
                                        />
                                    </div>
                                </div>

                                {/* Date of Entry */}
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Date of Entry</label>
                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods}
                                            value={this.state.expenseSearchForm.entry_date_range}
                                            startDate={this.state.expenseSearchForm.entry_date_range_start}
                                            endDate={this.state.expenseSearchForm.entry_date_range_end}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    expenseSearchForm: {
                                                        ...this.state.expenseSearchForm,
                                                        entry_date_range: period,
                                                        entry_date_range_start: startDate || null,
                                                        entry_date_range_end: endDate || null
                                                    }
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Transaction Period */}
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction Period</label>
                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods}
                                            value={this.state.expenseSearchForm.date_range}
                                            startDate={this.state.expenseSearchForm.date_range_start}
                                            endDate={this.state.expenseSearchForm.date_range_end}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    expenseSearchForm: {
                                                        ...this.state.expenseSearchForm,
                                                        date_range: period,
                                                        date_range_start: startDate || null,
                                                        date_range_end: endDate || null
                                                    }
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <ApplicationLayout>
                <Helmet><title>Expense Listing</title></Helmet>
                {this.expenseListjsx()}
                {this.expenseSearchModalJsx()}
            </ApplicationLayout>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token,
    all_periods: state.app?.all_periods || [],
    iam_asset_types: state.app?.asset_type || [],
    iam_group_sites: state.app?.group_sites || [],
    asset_groups: state.app?.asset_groups || []
});

export default connect(mapStateToProps)(Expense);